import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';
import { Inspection, Inspector, ListFilters, ListResults } from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class InspectorService {
  constructor(protected http: HttpClient) {}

  public list(filters?: ListFilters) {
    return this.http.get<ListResults<Inspector>>(`${env.APIUrl}/inspector`, { params: filters as any });
  }

  public get(id: number) {
    return this.http.get<Inspector>(`${env.APIUrl}/inspector/${id}`).toPromise();
  }

  public archived(filters?: ListFilters) {
    return this.http.get<ListResults<Inspector>>(`${env.APIUrl}/inspector/archived`, { params: filters as any });
  }

  public archive(id: number) {
    return this.http.put<Inspector>(`${env.APIUrl}/inspector/${id}/archive`, null).toPromise();
  }

  public remove(id: number) {
    return this.http.delete<Inspector>(`${env.APIUrl}/inspector/${id}`).toPromise();
  }

  public restore(id: number) {
    return this.http.put<Inspector>(`${env.APIUrl}/inspector/${id}/restore`, null).toPromise();
  }

  public edit(id: number, inspector: Inspector) {
    return this.http.put<Inspector>(`${env.APIUrl}/inspector/${id}`, inspector).toPromise();
  }

  public create(inspector: Inspector) {
    return this.http.post<Inspector>(`${env.APIUrl}/inspector`, inspector).toPromise();
  }

  public inspections(inspectorId: number) {
    return this.http.get<Inspection[]>(`${env.APIUrl}/inspector/${inspectorId}/inspections`);
  }

  public count() {
    return this.http.get<{ active: boolean; count: number }[]>(`${env.APIUrl}/inspector/count`).toPromise();
  }

  public inspectorsWithMiles(params?: any) {
    return this.http.get<ListResults<Inspector>>(`${env.APIUrl}/inspector/inspectorsWithMiles`, {
      params: params as any,
    });
  }

  public getInspectorWithMiles(params?: any) {
    return this.http
      .get<Inspector>(`${env.APIUrl}/inspector/getInspectorWithMiles`, {
        params: params as any,
      })
      .toPromise();
  }
}
